import { useGetEquiposVentasQuery } from "../../../../api/vendedorApi";
import { EquipoVentas } from "../../../../types/vendedor";
import { EquiposListContainer } from "./EquiposContainer";
import { VendedoresList } from "./VendedoresList";

interface Props {
    equipos?: EquipoVentas[];
}

export function EquiposVentas({ equipos }: Props) {

    return (
        <EquiposListContainer
            title="Equipos de ventas">
            <div className="h-[22.5px] my-2 "></div>
            <VendedoresList
                equipos={equipos}/>
        </EquiposListContainer>
    );
}

